/**
 * @generated SignedSource<<b3898ef6ab6917a1139f9fcb093f615b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePrerenderedCheckout_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"redirectToPrerenderedCheckout_item">;
  readonly " $fragmentType": "usePrerenderedCheckout_item";
};
export type usePrerenderedCheckout_item$key = {
  readonly " $data"?: usePrerenderedCheckout_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePrerenderedCheckout_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "usePrerenderedCheckout_item",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "redirectToPrerenderedCheckout_item",
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "getCheckoutUrl_item",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "defaultSkuId",
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "c784f3d3e3a16689f246d72462d1903b";

export default node;
